import { BaseService, IGetList } from '../base/base.service';
import { AppService } from '../main/app.service';

export class IApplicantStatusHistory {
    id: string;
    newStatus: string;
    description: string;
    date: any;
    applicantId: string;
}

export class ApplicantStatusHistoryService extends BaseService<IApplicantStatusHistory> {
    constructor(Restangular: Restangular.IService, protected AppService: AppService) {
        "ngInject";
        super(Restangular, AppService, 'hr/applicantStatusHistory');
    }

    public getPerApplicant = (applicantId : number | string): ng.IPromise<any> => {
        return this.Restangular.all(this.itemName).customGET('', {"applicantId" : applicantId }).then((response: Restangular.ICollection) => {
            return this.getListLoaded(response.plain());
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/services/applicantStatusHistory.service.ts